var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCheckDiscountIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.667 7A6.667 6.667 0 11.334 7a6.667 6.667 0 0113.333 0zM6.23 10.53l4.946-4.946a.43.43 0 000-.608l-.608-.609a.43.43 0 00-.609 0L5.925 8.401 4.042 6.518a.43.43 0 00-.608 0l-.608.608a.43.43 0 000 .608L5.62 10.53a.43.43 0 00.609 0z",
    fill: "#25B000"
  })));
}

export default SvgCheckDiscountIcon;